import * as styledComponents from "styled-components";
import { capturePropsUtil } from "./capturePropsUtil";
import { MaterialThemeProvider } from "./MaterialThemeProvider";
import { RMWCProvider } from "./RMWCProvider";
import {
  CELL_SPACING,
  createTheme,
  defaultTheme,
  navigationTheme,
  SizeSet,
  Theme,
} from "./themes";
import {
  accentButtonBackground,
  accentButtonBorder,
  accentButtonHoverBackground,
  backgroundTheme,
  brandButtonBackground,
  brandButtonBorder,
  brandButtonHoverBackground,
  BreakpointDown,
  BreakpointUp,
  buttonColor,
  cellBackground,
  colorStyle,
  darkPalette,
  ellipsis,
  getReadableColorValue,
  inputBackground,
  inputColor,
  inputPlaceholderColor,
  materialBackground,
  MaterialBreakpointDown,
  MaterialBreakpointUp,
  materialHoverBackground,
  MediaType,
  menuBackground,
  menuButtonBackground,
  menuButtonHoverBackground,
  primaryBorder,
  readableColor,
  scrollbars,
  secondaryBorder,
  shadow,
  sidebarBackground,
  styledConditional,
  styledMedia,
  styledSourceType,
  styledThemeName,
  terminalBackground,
  themeNameStyle,
  windowBackground,
} from "./themeStyles";
import {
  ThemeButtonProps,
  ThemeName,
  ThemeProps,
  WithThemeName,
} from "./types";

const {
  default: styled,
  css,
  createGlobalStyle,
  keyframes,
  ThemeProvider,
  ThemeContext,
} = styledComponents as styledComponents.ThemedStyledComponentsModule<Theme>;

export {
  BreakpointDown,
  BreakpointUp,
  css,
  createGlobalStyle,
  keyframes,
  ThemeProvider,
  ThemeContext,
  MaterialThemeProvider,
  RMWCProvider,
  Theme,
  ThemeProps,
  ThemeButtonProps,
  createTheme,
  defaultTheme,
  navigationTheme,
  SizeSet,
  ThemeName,
  WithThemeName,
  CELL_SPACING,
  backgroundTheme,
  cellBackground,
  colorStyle,
  darkPalette,
  ellipsis,
  materialBackground,
  MaterialBreakpointDown,
  MaterialBreakpointUp,
  materialHoverBackground,
  MediaType,
  menuBackground,
  menuButtonBackground,
  menuButtonHoverBackground,
  accentButtonBackground,
  accentButtonHoverBackground,
  accentButtonBorder,
  brandButtonBackground,
  brandButtonBorder,
  brandButtonHoverBackground,
  buttonColor,
  inputColor,
  inputPlaceholderColor,
  inputBackground,
  primaryBorder,
  readableColor,
  getReadableColorValue,
  scrollbars,
  secondaryBorder,
  shadow,
  sidebarBackground,
  styledConditional,
  styledMedia,
  styledSourceType,
  styledThemeName,
  terminalBackground,
  themeNameStyle,
  windowBackground,
};
export const withTheme = styledComponents.withTheme;
export const captureProps = capturePropsUtil;
export default styled;
